import ProjectNamespaceTreeItem from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectNamespaceTreeItem";
import ProjectNamespaceTreeRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectNamespaceTreeRequest";
import ProjectNamespaceTreeResponse from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectNamespaceTreeResponse";
import {
  CreateGroupModel,
  CreateQueueModel,
  GroupModel,
  NamespaceModel,
  QueueTasksModel,
  UpdateGroupNameModel,
  UpdateNamespaceNameModel,
  UpdateQueueNameModel,
} from "../models";
import ProjectGroupTreeItem from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectGroupTreeItem";
import ProjectQueueTaskListItem from "@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/ProjectQueueTaskListItem";
import GroupCreateRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/GroupCreateRequest";
import GroupRemoveRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/GroupRemoveRequest";
import ProjectQueueTaskCreateRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/ProjectQueueTaskCreateRequest";
import GroupUpdateNameRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/GroupUpdateNameRequest";
import QueueTaskUpdateNameRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/QueueTaskUpdateNameRequest";
import ProjectNamespaceDeleteRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectNamespaceDeleteRequest";
import ProjectTaskQueueDeleteRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/queue-tasks/ProjectTaskQueueDeleteRequest";
import ProjectNamespaceUpdateNameRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectNamespaceUpdateNameRequest";
import GetNamespaceByIdResponse from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/GetNamespaceByIdResponse";
import { UserModel } from "@/pages/namespace-team-page/models";
import GetNamespaceByIdRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/GetNamespaceByIdRequest";
import GetCountEmployeesUserRequest from "@/api/Main/dataSource/api/projects/performers/i-service/model/request/GetCountEmployeesUserRequest";

export const mapGetNamespaceAdminsRequest = (namespaceId: string) =>
  new GetNamespaceByIdRequest({
    NamespaceId: namespaceId,
  });

export const mapGetNamespaceAdminsResponse = (response: GetNamespaceByIdResponse) =>
  response.AdminList.map(
    (user) =>
      new UserModel({
        Id: user.UserId,
        FirstName: user.FirstName,
        LastName: user.LastName,
        MiddleName: user.MiddleName,
        Photo: user.Foto,
        AvatarColor: user.AvatarColor,
      }),
  );

export const mapGetTreeRequest = (projectId: number, onlyConfigured?: boolean) =>
  new ProjectNamespaceTreeRequest({ ProjectId: projectId, OnlyConfigured: onlyConfigured });

const mapQueueTaskItem = (
  item: ProjectQueueTaskListItem,
  parentGroupId?: number,
  namespaceId?: string,
  isAdminNamespace: boolean = false,
) => {
  return new QueueTasksModel({
    Id: item.Id,
    Name: item.Name,
    Number: item.Number,
    NamespaceId: item.NamespaceId ?? namespaceId,
    ParentGroupId: parentGroupId,
    IsConfigured: item.IsConfigured,
    TaskCount: item.TaskCount,
    IsAdminNamespace: isAdminNamespace,
    //TODO убрать as any после залива
  });
};

const mapGroupTreeItem = (item: ProjectGroupTreeItem, isAdminNamespace: boolean = false) => {
  return new GroupModel({
    Id: item.Id,
    Name: item.Name,
    NamespaceId: item.NamespaceId,
    ParentGroupId: item.ParentGroupId,
    Number: item.Number,
    IsAdminNamespace: isAdminNamespace,
    Groups: item.ChildrenGroups?.length
      ? sortByName(item.ChildrenGroups.map((group) => mapGroupTreeItem(group, isAdminNamespace)))
      : [],
    QueueTasks: item.QueueTasks?.length
      ? sortByName(
          item.QueueTasks.map((x) =>
            mapQueueTaskItem(x, item.Id, item.NamespaceId, isAdminNamespace),
          ),
        )
      : [],
  });
};

const mapNamespaceTreeItem = (item: ProjectNamespaceTreeItem) => {
  return new NamespaceModel({
    Id: item.Id,
    Name: item.Name,
    IconId: item.IconId,
    IconUrl: item.IconUrl,
    ColorId: item.ColorId,
    Color: item.Color,
    IsAdminNamespace: item.IsAdmin,
    Groups: item.Groups?.length
      ? sortByName(item.Groups.map((group) => mapGroupTreeItem(group, item.IsAdmin)))
      : [],
    QueueTasks: item.QueueTasks?.length
      ? sortByName(
          item.QueueTasks.map((_item) =>
            mapQueueTaskItem(_item, undefined, _item.Id, item.IsAdmin),
          ),
        )
      : [],
  });
};

const sortByName = (items: any[]) => {
  return items.sort((a, b) => a?.Name.localeCompare(b?.Name));
};

export const mapGetTreeResponse = (resposnse: ProjectNamespaceTreeResponse) => {
  const namespaces = resposnse.Namespaces.map(mapNamespaceTreeItem);
  return sortByName(namespaces);
};

export const mapCreateGroupRequest = (request: CreateGroupModel) =>
  new GroupCreateRequest({
    NamespaceId: request.NamespaceId,
    ParentId: request.ParentGroupId,
    Name: request.Name,
  });

export const mapDeleteGroupRequest = (groupId: number) =>
  new GroupRemoveRequest({
    GroupId: groupId,
  });

export const mapCreateQueueRequest = (request: CreateQueueModel) =>
  new ProjectQueueTaskCreateRequest({
    Name: request.Name,
    GroupId: request.GroupId,
    NamespaceId: request.NamespaceId,
  });

export const mapUpdateGroupName = (request: UpdateGroupNameModel) =>
  new GroupUpdateNameRequest({
    GroupId: request.GroupId,
    Name: request.Name,
  });

export const mapUpdateQueueName = (request: UpdateQueueNameModel) =>
  new QueueTaskUpdateNameRequest({
    QueueTaskId: request.QueueId,
    Name: request.Name,
  });

export const mapDeleteNamespaceRequest = (namespaceId: string) =>
  new ProjectNamespaceDeleteRequest({
    NamespaceId: namespaceId,
  });

export const mapDeleteQueueRequest = (queueId: string) =>
  new ProjectTaskQueueDeleteRequest({
    QueueTaskId: queueId,
  });

export const mapUpdateNamespaceName = (request: UpdateNamespaceNameModel) =>
  new ProjectNamespaceUpdateNameRequest({
    Id: request.NamespaceId,
    Name: request.Name,
  });

export const mapGetMyTeamCountEmployeesRequest = (userId: number) =>
  new GetCountEmployeesUserRequest({
    UserId: userId,
  });
